import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useSelector } from "react-redux";
import AlertBanner from "canvas-core-react/lib/AlertBanner";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
import PrimaryButton from "canvas-core-react/lib/PrimaryButton";

import CustomInput from "../../shared/custom-components/customInput";
import ErrorMessage from "../../shared/custom-components/errorMessage";
import MainTemplate from "../mainTemplate";
import Modal from "../../utils/customModal";
import useApi from "../../hooks/useApi";
import useForm from "../../hooks/useForm";
import { loadingHtml } from "../../utils/functions";
import { getSessionInfo } from "../../../Redux/reducer/session";

const ProviderConfiguration = () => {
  const [alert, setAlert] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [initialState, setInitialState] = useState({ days: "" });
  const [daysToDiscount, setDaysToDiscount] = useState();

  const { countryCode, institutionId, allCompanies } =
    useSelector(getSessionInfo);

  const history = useHistory();
  const { t } = useTranslation();
  const { getApiCAll, postApiCAll } = useApi();

  const callback = async ({ days }) => {
    try {
      setShowModal(true);
      await postApiCAll(
        `/companies/add-days-expire-bills-all-provider/${institutionId}`,
        {
          daysToExpireBillsOfCompanyAllProvider: days,
          isCifCross: allCompanies,
        }
      );
      setAlert("success");
    } catch (error) {
      setAlert("error");
    }
    setShowModal(false);
  };

  const range = { min: 1, max: countryCode === "PA" ? 350 : 165 };

  const text = t("providerConfiguration", {
    returnObjects: true,
    num: daysToDiscount,
  });
  const buttonsLabel = t("general.buttons", { returnObjects: true });

  const goBack = () => {
    history.push("/providers");
  };

  useEffect(() => {
    const getInitialData = async () => {
      setShowModal(true);
      try {
        const [{ data: daysExpireResponse }, { data: daysToDiscountResponse }] =
          await Promise.all([
            getApiCAll(
              `/companies/days-expire-bills-all-provider/${institutionId}`
            ),
            getApiCAll(`/parameters/days-to-discount/${countryCode}`),
          ]);

        setInitialState({
          days: daysExpireResponse.data?.daysToExpireBillsOfCompanyAll || "",
        });
        setDaysToDiscount(daysToDiscountResponse?.data.daysToDiscount);
      } catch (error) {
        console.log({ error });
      }
      setShowModal(false);
    };
    getInitialData();
  }, []);

  const { handleChange, values, errors, onSubmit } = useForm({
    initialState,
    callback,
    validation: {
      days: {
        isBetween: {
          msg: t("general.formErrors.between", range),
          parameters: range,
        },
      },
    },
  });

  return (
    <MainTemplate>
      <div className="providers-configuration">
        <h3 className={`mt-5 mb-3 ${errors.days ? "error" : ""}`}>
          {text.title}:
        </h3>
        <p>{text.subtitle}.</p>
        <div className="d-flex my-5">
          <CustomInput
            className="providers-configuration-input-container"
            name="days"
            value={values.days}
            onChange={handleChange}
            inputClass={`${errors.days ? "input-error" : ""} `}
            onlyNumber
          />
          <p className="ml-3 mt-3 font-weight-bold">{text.days}</p>
        </div>

        {errors.days && (
          <div className="mb-4 error-text-fix">
            <ErrorMessage error={t("general.formErrors.between", range)} />
          </div>
        )}

        <p>{text.message}.</p>

        <div className="form-actions clearfix">
          {alert && (
            <AlertBanner type={alert} className="my-5 configuration-alert">
              <>{text.alert[alert]}.</>
            </AlertBanner>
          )}
          <SecondaryButton onClick={goBack}>
            {buttonsLabel.back}
          </SecondaryButton>
          <PrimaryButton disabled={!values.days} onClick={onSubmit}>
            {buttonsLabel.save}
          </PrimaryButton>
        </div>
      </div>
      <Modal show={showModal}>{loadingHtml()}</Modal>
    </MainTemplate>
  );
};

export default ProviderConfiguration;
